<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">住院详情</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="no">
					<span style="width:85px;display: inline-block;text-align: right;">住院单号：</span>
					{{detail.id}}
				</div>
				<div class="msg">
					<div class="item">
						<div class="label">顾客姓名：</div>
						<div class="value">{{detail.memberName}}</div>
					</div>
					<div class="item">
						<div class="label">手机号码：</div>
						<div class="value">{{detail.memberMobile}}</div>
					</div>
					<div class="item">
						<div class="label">宠物昵称：</div>
						<div class="value">{{detail.petName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物品种：</div>
						<div class="value">{{detail.typeName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物性别：</div>
						<div class="value">{{detail.sex}}</div>
					</div>
					<div class="item">
						<div class="label">宠物年龄：</div>
						<div class="value" v-if="detail.birthDay&&detail.birthDay.length>4">
							{{$public.FTime(new Date(detail.birthDay).getTime(),'YYYY-MM-DD')}}
							<span style="color:#1853A4;">
								({{$public.FAge(new Date(detail.birthDay).getTime())[0]}}岁
								{{$public.FAge(new Date(detail.birthDay).getTime())[1]}}月)
							</span>
						</div>
					</div>
					<div class="item">
						<div class="label">住院服务：</div>
						<div class="value">{{detail.productName}} ( {{detail.inHospitalPrice}}元/天 )</div>
					</div>
					<div class="item">
						<div class="label">创建时间：</div>
						<div class="value">{{$public.FTime(detail.createTime,'YYYY-MM-DD HH:mm')}}</div>
					</div>
					<div class="item">
						<div class="label">住院开始时间：</div>
						<div class="value">{{$public.FTime(detail.beginDate,'YYYY-MM-DD')}}</div>
					</div>
					<div class="item">
						<div class="label">住院结束时间：</div>
						<div class="value">
							{{$public.FTime(detail.createEndDate,'YYYY-MM-DD')}}
						</div>
					</div>
					<div class="item">
						<div class="label">已住院时间：</div>
						<div class="value">{{detail.inHospitalDuration}}</div>
					</div>
					<div class="item">
						<div class="label">押金：</div>
						<div class="value" v-if="detail.depositType==1">
							{{detail.deposit}}
						</div>
					</div>
					<div class="item">
						<div class="label">余额：</div>
						<div class="value" v-if="detail.depositType==2">{{detail.deposit}}</div>
					</div>
					<div class="item">
						<div class="label">支付方式：</div>
						<div class="value" v-if="detail.depositType==1">
							{{$public.formatPayTypeState(detail.payType)}}
						</div>
					</div>
					<div class="item">
						<div class="label">已支付住院费：</div>
						<div class="value">
							<span style="color:#32A05B">{{detail.payInHospitalMoney}}元</span>
						</div>
					</div>
					<div class="item">
						<div class="label">应支付住院费：</div>
						<div class="value">
							<span>{{detail.inHospitalMoney}}元</span>
						</div>
					</div>
					<div class="item">
						<div class="label">是否欠费：</div>
						<div class="value">
							<span v-if="$public.jian(detail.inHospitalMoney,detail.payInHospitalMoney)>0" style="color:red">是</span>
							<span v-else style="color:#32A05B;">否</span>
						</div>
					</div>
					<div class="item">
						<div class="label">已超时时间：</div>
						<div class="value">{{detail.overDuration}}</div>
					</div>
					<div class="item">
						<div class="label">紧急联系人：</div>
						<div class="value">
							{{detail.contactName}}
						</div>
					</div>
					<div class="item">
						<div class="label">联系电话：</div>
						<div class="value">
							{{detail.contactMobile}}
						</div>
					</div>
					<div class="item">
						<div class="label">经办人：</div>
						<div class="value">
							{{detail.handlerName}}
						</div>
					</div>
					<div class="item">
						<div class="label">备注：</div>
						<div class="value">
							{{detail.remark}}
						</div>
					</div>
				</div>
				<div class="relation">
					<div v-if="detail.payInfo&&detail.payInfo.payCount===0">
						<el-button style="width:120px;" type="info" size="medium">未支付</el-button>
					</div>
					<div v-else>
						<el-button v-if="detail.status==1" style="width:120px;" type="info" size="medium">住院中</el-button>
						<el-button v-if="detail.status==2" style="width:120px;" type="info" size="medium">已离院</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				detail: {},
			}
		},
		computed:{
			zhuyuanParams(){
				return this.$store.state.yiliaoxin.zhuyuanParams;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			back(){
				this.$store.commit("yiliaoxin/remove_router")
				if(this.$store.state.yiliaoxin.router.length===0){
					this.zhuyuanParams.type = 'list'
					this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
					this.$store.commit('yiliaoxin/set_curBusiness','住院')
				}
				// if(
				// 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
				// ){
				// 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
				// 	return 
				// }
				// this.zhuyuanParams.type = 'list'
				// this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
			},
			getTableData(){
				let params = {
					"inHospitalId": this.zhuyuanParams.curRow.id,
				}
				this.$http.get('/api/InHospital/Detail', params).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:23px 0 20px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.no{
					font-size: 14px;color:$fontColor;font-weight: bold;padding:0 24px 24px;
				}
				.msg{
					display: flex;flex-wrap: wrap;padding:0 24px 8px;
					.item{
						width:20%;font-size: 12px;color:$fontColor;display: flex;padding-bottom:16px;
						.label{
							width:85px;text-align: right;line-height: 32px;
						}
						.value{
							text-align: left;line-height: 32px;
						}
					}
				}
				.relation{
					padding:0 24px 8px;text-align: right;
				}
			}
		}
	}
</style>
